/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { ShipmentGroupSpOfferRequestSummaryVO, ShipmentGroupSpOrderSummaryVO } from '@well/domain';
import { ShipmentVoModel } from './shipment-vo.model';

export class SingleShipmentGroupSolutionMetadataModel extends JSONable {

  remainingShipmentDraftVos: ShipmentVoModel[] | undefined = undefined;

  originalShipmentVos: ShipmentVoModel[] | undefined = undefined;

  shipmentGroupSpOfferRequestSummaryVOs: ShipmentGroupSpOfferRequestSummaryVO[] | undefined = undefined;

  shipmentGroupSpOrderSummaryVOs: ShipmentGroupSpOrderSummaryVO[] | undefined = undefined;

  existsMasterRoutingSolWithTasksOrOrders: boolean | undefined = undefined;

}

